export const GET_REGISTRATION_FORMS_REQUEST = 'GET_REGISTRATION_FORMS_REQUEST';
export const GET_REGISTRATION_FORMS_SUCCESS = 'GET_REGISTRATION_FORMS_SUCCESS';
export const GET_REGISTRATION_FORMS_FAILED = 'GET_REGISTRATION_FORMS_FAILED';

export const DELETE_REGISTRATION_FORMS_REQUEST = 'DELETE_REGISTRATION_FORMS_REQUEST';
export const DELETE_REGISTRATION_FORMS_SUCCESS = 'DELETE_REGISTRATION_FORMS_SUCCESS';
export const DELETE_REGISTRATION_FORMS_FAILED = 'DELETE_REGISTRATION_FORMS_FAILED';
